import axios from 'axios'
import { getAppConfigSetting } from '../utils'
import { CORRESPONDENTS_API } from './constants'

const getCorrespondentUrl = (accountNumber: string) => {
  return `${getAppConfigSetting('apiUrl')}${CORRESPONDENTS_API}?account=${accountNumber}`
}

export const getCorrespondent = (accountNumber: string) =>
  axios.get(getCorrespondentUrl(accountNumber), { withCredentials: true })
